import type { RequestEvent } from '@sveltejs/kit';
import { browser } from '$app/environment';

// store noGarnish value in memory on the client side
// so subsequent removal of the query param does not activate it
let noGarnishBrowser: boolean | null = null;

/**
 * function to check if noGarnish is enabled.
 * During SSR, you have to provide the request event so we can check the url param
 * In the browser, we check location.search directly.
 *
 * @param event
 */
export function isNogarnish(event?: RequestEvent): boolean {
	if (browser) {
		if (noGarnishBrowser === null) {
			noGarnishBrowser = hasNogarnishParam(new URLSearchParams(location.search));
		}
		return noGarnishBrowser;
	} else {
		if (!event) {
			throw new Error('during SSR, event has to be set');
		}
		return hasNogarnishParam(event.url.searchParams);
	}
}

function hasNogarnishParam(usp: URLSearchParams) {
	return usp.get('noGarnish') === 'true';
}
